import React, { useCallback } from 'react';

import { View } from 'react-native';

import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

import Close from 'assets/images/svgs/ico_close.svg';

import gStyles from 'config/styles';

import { RouteNavigationParams } from 'router/types';

import isFunction from 'utils/function';

import SvgButton from 'components/CustomButtons/SvgButton';

import styles from './styles';

type Props = {
    needsClose?: boolean;
    onCloseButton?: () => void;
};

function SimpleNavigationHeaderRight({
    needsClose = false,
    onCloseButton,
}: Props) {
    const navigation =
        useNavigation<
            StackNavigationProp<
                RouteNavigationParams,
                keyof RouteNavigationParams
            >
        >();

    const handleOnClose = useCallback(() => {
        if (isFunction(onCloseButton)) {
            onCloseButton();
        } else {
            navigation.popToTop();
        }
    }, [onCloseButton]);

    return (
        <View
            style={[
                styles.container,
                gStyles.headerDefaultPaddingRight,
                gStyles.headerContainer,
            ]}
        >
            {needsClose && <SvgButton Svg={Close} onPress={handleOnClose} />}
        </View>
    );
}

export default SimpleNavigationHeaderRight;
